import { createEntityAdapter } from '@reduxjs/toolkit';

import { State } from 'Libs/redux/reducer';

import type { ContentListItem } from '../common/types';
import type { State as ContentListState } from './content.list.types';

export const contentListAdaptater = createEntityAdapter<ContentListItem>({ selectId: (item) => item.id });

const { selectAll } = contentListAdaptater.getSelectors();

const selectContentListState = (state: State): ContentListState => state.entities.contentList;

export const selectContentListMetadata = (state: State) => selectContentListState(state).metadata;

export const selectContentListItems = (state: State) => selectAll(state.entities.contentList);
